module.exports = __webpack_public_path__ + "static/media/exo-latin-800.68eb65d6.woff";